const state = {
    showBurgerMenu: false,
    activeDropdown: null,
};

const mutations = {
    setShowBurgerMenu(state, show) {
        state.showBurgerMenu = show;
    },
    SET_ACTIVE_DROPDOWN(state, dropdownId) {
        state.activeDropdown = dropdownId;
    },
};

const actions = {
    setShowBurgerMenu({ commit, dispatch }, show) {
        commit('setShowBurgerMenu', show);
        dispatch('updateMainActiveClass', show);
    },
    setActiveDropdown({ commit }, dropdownId) {
        commit('SET_ACTIVE_DROPDOWN', dropdownId);
    },
    updateMainActiveClass(_, show) {
        const mainElement = document.querySelector('main');
        if (mainElement) {
            if (show && window.innerWidth <= 992) mainElement.classList.add('active');
            else mainElement.classList.remove('active');
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
